import { PERMISSIONS } from "../../../constants/permissions";

interface UserWithPermissions {
	permissions?: string[];
}

// Admin: has "endpoint_request.delete_endpointrequest"
export function isAdmin(user?: UserWithPermissions | null): boolean {
	return !!user?.permissions?.includes(PERMISSIONS.ENDPOINT_REQUEST_ADMIN);
}

// Backend dev: has "endpoint_request.change_endpointrequest"
export function isBackendDev(user?: UserWithPermissions | null): boolean {
	return !!user?.permissions?.includes(PERMISSIONS.ENDPOINT_REQUEST_BACKEND);
}

// Frontend dev: has BOTH "endpoint_request.add_endpointrequest" AND "endpoint_request.add_component"
export function isFrontendDev(user?: UserWithPermissions | null): boolean {
	const perms = user?.permissions || [];
	return (
		perms.includes(PERMISSIONS.ENDPOINT_REQUEST_FRONTEND_ADD_REQUEST) &&
		perms.includes(PERMISSIONS.ENDPOINT_REQUEST_FRONTEND_ADD_COMPONENT)
	);
}
